import TemplateNames from './TemplateNames';

export default {
  title: 'Lähetetyt viestit',
  columns: {
    recipient: 'Vastaanottaja',
    template: 'Malli',
    status: 'Tila',
    opened: 'Avattu',
    clicked: 'Napsautettu',
    sent_at: 'Lähetetty',
  },
  labels: {
    empty_list: 'Ei vielä lähetettyjä viestejä',
    load_failed: 'Lähetettyjä viestejä ei voitu ladata. Lataa sivu uudelleen tai ota yhteyttä tukeen.',
    yes: 'Kyllä',
    no: 'Ei',
    clicked_at: 'Napsautettu: {{date}}',
    opened_at: 'Avattu: {{date}}',
  },
  message_statuses: {
    sent: 'Lähetetty',
    delivered: 'Toimitettu',
    failed: 'Epäonnistui',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
